import axios from 'axios';
import { TEST_SERVER_URL, NGOROMSO_SERVER_URL } from '../constants/Common';

// export default axios.create({
//   baseURL: `http://${TEST_SERVER_URL}:3004/`,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });


export const adminAPI = axios.create({
  baseURL: `http://${TEST_SERVER_URL}:3004/`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Second instance
export const ngoromsoAPI = axios.create({
  baseURL: `${NGOROMSO_SERVER_URL}`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// const intentAPI = () => {
//   return axios.create({
//     baseURL: `http://localhost:3001/v2/`,//YOUR_API_URL HERE
//     headers: {
//       'Content-Type': 'application/json',
//     }
//   });
// }
